import { defineStore } from "pinia";
import { state } from "./state";
import { actions } from "./actions";
import { getters } from "./getters";
import { id } from "./id";

export const useProcessStore = defineStore({
  id,
  state,
  actions,
  getters,
  persist: {
    omit: ["selectedPlan.promoCodePrice"],
  },
});
